module.exports = __webpack_public_path__ + "img/padBg.218dc771.png";